import { type Ref } from 'react';
import classNames from 'classnames';
import VerificationInputImport from 'react-verification-input';
import styles from './FormVerifyCode.module.scss';

// `react-verification-input` is a webpack-built CJS package whose runtime
// shape (`module.exports.default = Component`) is double-wrapped by Vite's
// esbuild CJS→ESM interop, so the default import is `{ default: Component }`.
const VerificationInput =
  (
    VerificationInputImport as unknown as {
      default?: typeof VerificationInputImport;
    }
  ).default ?? VerificationInputImport;

type FormVerifyCodeProps = {
  ariaLabel?: string;
  className?: {
    label?: string;
    input?: string;
  };
  disabled?: boolean;
  id: string;
  label: string;
  onChange?: (code: string) => void;
  onComplete?: (code: string) => void;
  ref?: Ref<HTMLInputElement>;
  value?: string;
};

const FormVerifyCode = ({
  ariaLabel,
  className,
  disabled,
  id,
  label,
  onChange,
  onComplete,
  ref,
  value,
}: FormVerifyCodeProps) => {
  return (
    <>
      <label
        htmlFor={id}
        className={classNames(styles.label, className?.label)}
      >
        {label}
      </label>
      <VerificationInput
        ref={ref}
        classNames={{
          container: classNames(styles.container, className?.input, {
            [styles.disabled]: disabled,
          }),
          character: styles.character,
          characterInactive: styles.characterInactive,
          characterSelected: styles.characterSelected,
          characterFilled: styles.characterFilled,
        }}
        inputProps={{
          autoComplete: 'one-time-code',
          id: 'code',
          className: styles.input,
          'aria-label': ariaLabel,
          disabled,
          inputMode: 'numeric',
        }}
        length={6}
        onChange={onChange}
        onComplete={onComplete}
        placeholder="|"
        validChars="/0-9/"
        value={value}
      />
    </>
  );
};

export default FormVerifyCode;
